import React, { useEffect, useState } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import perifoneoImagen from "../../assets/img/megafono.png";
import ReactAudioPlayer from 'react-audio-player';
import Button from "react-bootstrap/Button";
import { obtenerArchivos, descargarArchivo } from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const Perifoneos = () => {
    const [tracks, setTracks] = useState([]);
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
    const seccionId = 16; // Sección para los perifoneos

    useEffect(() => {
        const cargarPerifoneos = async () => {
            const result = await obtenerArchivos({ seccionId });
            if (result && result.success) {
                // Convertir los archivos en tracks para el reproductor
                const nuevosTracks = result.archivos.map(archivo => {
                    const parts = archivo.nombre_completo.split("_");
                    let displayTitle = archivo.nombre_archivo; // Valor por defecto
                    if (parts.length >= 3) {
                        const timestamp = parseInt(parts[1], 10);
                        const date = new Date(timestamp * 1000);
                        const monthNames = [
                            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                        ];
                        const month = monthNames[date.getMonth()];
                        const year = date.getFullYear();
                        displayTitle = `${month} ${year}`;
                    }
                    return {
                        url: archivo.ruta_archivo,         // URL del archivo
                        title: displayTitle,                 // Título formateado para mostrar
                        originalName: archivo.nombre_archivo, // Nombre original para la descarga
                        tags: ['Perifoneo'],
                    };
                });
                setTracks(nuevosTracks);
                setCurrentTrackIndex(0);
            } else {
                console.error("No se pudieron cargar los perifoneos.");
            }
        };

        cargarPerifoneos();
    }, []);

    // Avanza al siguiente track cuando termina el actual
    const handleEnded = () => {
        if (currentTrackIndex + 1 < tracks.length) {
            setCurrentTrackIndex(currentTrackIndex + 1);
        } else {
            console.log("Se ha finalizado la lista de reproducción");
        }
    };

    // Descarga el track actual usando el nombre original
    const handleDownload = () => {
        if (tracks.length > 0) {
            descargarArchivo(seccionId, tracks[currentTrackIndex].originalName);
        }
    };

    // Cambia manualmente al track anterior
    const handlePrev = () => {
        if (currentTrackIndex > 0) {
            setCurrentTrackIndex(currentTrackIndex - 1);
        }
    };

    // Cambia manualmente al siguiente track
    const handleNext = () => {
        if (currentTrackIndex + 1 < tracks.length) {
            setCurrentTrackIndex(currentTrackIndex + 1);
        }
    };

    return (
        <section style={{ paddingTop: '120px' }}>
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1 className="banner-title text-center">Perifoneos</h1>
                </div>

                <div className="player-card">
                    {tracks.length > 0 ? (
                        <>
                            {/* Contenedor integrado para imagen, reproductor y controles */}
                            <div
                                style={{
                                    background: '#e9ecef',
                                    padding: '20px',
                                    borderRadius: '8px'
                                }}
                            >
                                {/* Imagen centrada */}
                                <div className="text-center">
                                    <img
                                        src={perifoneoImagen}
                                        alt="Megáfono"
                                        className="img-fluid"
                                        style={{ maxWidth: '150px' }}
                                    />
                                </div>
                                <h5 className="text-black text-center mt-2">
                                    {tracks[currentTrackIndex].title}
                                </h5>
                                <ReactAudioPlayer
                                    src={tracks[currentTrackIndex].url}
                                    controls
                                    autoPlay
                                    onEnded={handleEnded}
                                />
                                <div className="d-flex justify-content-center mt-2">
                                    {tracks.length > 1 && (
                                        <>
                                            <Button
                                                variant="secondary"
                                                onClick={handlePrev}
                                                disabled={currentTrackIndex === 0}
                                            >
                                                <i className="bi bi-skip-backward-fill"></i>
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                onClick={handleNext}
                                                disabled={currentTrackIndex === tracks.length - 1}
                                                className="mx-2"
                                            >
                                                <i className="bi bi-skip-forward-fill"></i>
                                            </Button>
                                        </>
                                    )}
                                    <Button
                                        variant="secondary"
                                        onClick={handleDownload}
                                        className="ms-2"
                                    >
                                        <i className="bi bi-download"></i>
                                    </Button>
                                </div>

                                <div className="mt-3">
                                    <h6 className="text-center">Lista de reproducción</h6>
                                    <ListGroup>
                                        {tracks.map((track, index) => (
                                            <ListGroup.Item
                                                key={index}
                                                active={index === currentTrackIndex}
                                                onClick={() => setCurrentTrackIndex(index)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {track.title}
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </div>
                            </div>
                        </>
                    ) : (
                        <p className="text-black text-center">No hay perifoneos disponibles.</p>
                    )}
                </div>
            </Container>
        </section>
    );
};
